import { IRecomendacaoModel } from "./../../models/recomendacao.model";
import {
	AfterViewInit,
	Component,
	Inject,
	OnInit,
	ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
	MatDialog,
	MatDialogConfig,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import * as cloneDeep from "lodash/cloneDeep";
import { ToastrService } from "ngx-toastr";
import { IBaseModel } from "src/app/models/base.model";
import { IQuestaoModel } from "src/app/models/questao.model";
import { IQuestaoProcedimentoAuditoriaModel } from "src/app/models/questao-procedimento-auditoria.model";
import { IConstatacaoModel } from "src/app/models/constatacao.model";
import { IMatrizPlanejamentoModel } from "src/app/models/matriz-planejamento.model";
import { IMatrizPlanejamentoQuestaoModel } from "src/app/models/matriz-planejamento-questao.model";
import { IConstatacaoRecomendacaoModel } from "src/app/models/constatacao-recomendacao.model";
import { ISubtipoAuditoriaMatrizPlanejamentoModel } from "src/app/models/subtipo-auditoria-matriz-planejamento.model";
import { ISubtipoAuditoriaModel } from "src/app/models/subtipo-auditoria.model";
import { IQuestaoConstatacaoModel } from "src/app/models/questao-constatacao.model";
import { RecomendacaoService } from "src/app/services/recomendacao.service";
import { ConstatacaoService } from "src/app/services/constatacao.service";
import { BaseFormComponent } from "../../shared/components/base-form/base-form.component";
import { ModalRecomendacaoComponent } from "./modal-recomendacao/modal-recomendacao.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import Swal from "sweetalert2";

@Component({
	selector: "app-constatacao-form",
	templateUrl: "./constatacao-form.component.html",
	styleUrls: ["./constatacao-form.component.scss"],
})
export class ConstatacaoFormComponent
	extends BaseFormComponent
	implements OnInit, AfterViewInit
{
	@ViewChild("maxLengthEditor") private angularEditor: any;
	public model: IConstatacaoModel = {} as IConstatacaoModel;
	public modelConstatacaoRecomendacao: IConstatacaoRecomendacaoModel =
		{} as IConstatacaoRecomendacaoModel;
	public recomendacaoDataSource =
		new MatTableDataSource<IConstatacaoRecomendacaoModel>([]);
	public modelQuestao: IQuestaoModel = {} as IQuestaoModel;
	public modelMatrizPlanejamento: IMatrizPlanejamentoModel =
		{} as IMatrizPlanejamentoModel;
	public modelSubtipoAuditoria: ISubtipoAuditoriaModel =
		{} as ISubtipoAuditoriaModel;
	public listaProcedimentoAuditoria =
		new MatTableDataSource<IQuestaoProcedimentoAuditoriaModel>([]);
	public listaQuestao =
		new MatTableDataSource<IMatrizPlanejamentoQuestaoModel>([]);
	public listaConstatacao = [] as IQuestaoConstatacaoModel[];
	public listaMatrizPlanejamento =
		new MatTableDataSource<ISubtipoAuditoriaMatrizPlanejamentoModel>([]);
	public listaRecomendacoes: any[] = [] as any[];
	public rotaPrefixoSubtipoAuditoria = undefined;
	public rotaPrefixoMatrizPlanejamento = undefined;
	public semDados = true;

	public isModal: boolean = false;

	public form = new FormGroup({
		nome: new FormControl("", Validators.required),
		descricao: new FormControl("", Validators.required),
		contaGovernador: new FormControl(false, Validators.required),
		contaOrdenador: new FormControl(false, Validators.required),
	});

	constructor(
		route: ActivatedRoute,
		toastr: ToastrService,
		router: Router,
		localeService: BsLocaleService,
		private recomendacaoService: RecomendacaoService,
		private constatacaoService: ConstatacaoService,
		public matDialog: MatDialog,
		public dialogRef: MatDialogRef<ConstatacaoFormComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		super(route, toastr, router, localeService, matDialog);
		if (data?.isModal) {
			this.isModal = data?.isModal;
		}
		if (this.novoRegistro) {
			this.titulo = "Nova Constatação";
		}
	}

	config: AngularEditorConfig = {
		editable: !this.visualizar,
		spellcheck: true,
		sanitize: false,
		height: "15rem",
		minHeight: "5rem",
		placeholder: "",
		translate: "yes",
		defaultParagraphSeparator: "p",
		defaultFontName: "Arial",
		toolbarHiddenButtons: [],
		customClasses: [
			{
				name: "quote",
				class: "quote",
			},
			{
				name: "redText",
				class: "redText",
			},
			{
				name: "titleText",
				class: "titleText",
				tag: "h1",
			},
		],
	};

	async ngOnInit() {
		await this.buscarRecomendacoes();
		this.state();
		await this.carregarDetalhes();
	}

	ngAfterViewInit() {
		const editorElement = this.angularEditor?.textArea?.nativeElement;

		if (editorElement) {
			editorElement.addEventListener(
				"keydown",
				this.maxLengthAngularEditor.bind(this),
				false
			);

			editorElement.addEventListener("paste", (event: ClipboardEvent) => {
				event.preventDefault();

				const clipboardData = event.clipboardData || (window as any).clipboardData;
				const pastedText = clipboardData?.getData("text") || "";

				// Captura o texto atual visível, sem HTML
				const textoAtual = editorElement.innerText?.replace(/\s+/g, " ").trim() || "";
				const pastedLimpo = pastedText.replace(/\s+/g, " ").trim();

				const totalAtual = textoAtual.length;
				const restante = 1000 - totalAtual;

				if (restante > 0) {
					const textoPermitido = pastedLimpo.substring(0, restante);
					document.execCommand("insertText", false, textoPermitido);
				}
			});

		}
	}

	public maxLengthAngularEditor(e: KeyboardEvent) {
		const element = e.target as HTMLElement;
		const texto = element.innerText || ""; // Garante apenas o texto visível
		const max = 1000;

		const teclasPermitidas = [
			"Backspace",
			"Delete",
			"ArrowLeft",
			"ArrowRight",
			"ArrowUp",
			"ArrowDown",
			"Tab",
			"Control",
			"Meta",
			"Alt",
		];

		// Se ultrapassar o limite e não for uma tecla de controle, bloqueia
		if (texto.length >= max && !teclasPermitidas.includes(e.key)) {
			e.preventDefault();
		}
	}

	public async state() {
		// model questao
		this.modelQuestao = window.history.state.model;
		// model Subtipo Auditoria
		this.modelSubtipoAuditoria = window.history.state.modelSubtipoAuditoria;
		// model matriz planejamento
		this.modelMatrizPlanejamento =
			window.history.state.modelMatrizPlanejamento;
		// lista procedimento
		this.listaProcedimentoAuditoria =
			window.history.state.listaProcedimentoAuditoria;
		// lista questão
		this.listaQuestao = window.history.state.listaQuestao;
		// lista constatacao
		this.listaConstatacao = window.history.state.listaConstatacao;
		// lista Matriz Planejamento
		this.listaMatrizPlanejamento =
			window.history.state.listaMatrizPlanejamento;
		// rota
		if (window.history.state.rotaPrefixoSubtipoAuditoria) {
			this.rotaPrefixoSubtipoAuditoria =
				window.history.state.rotaPrefixoSubtipoAuditoria;
		}
		if (window.history.state.rotaPrefixoMatrizPlanejamento) {
			this.rotaPrefixoMatrizPlanejamento =
				window.history.state.rotaPrefixoMatrizPlanejamento;
		}
	}

	public async buscarRecomendacoes() {
		const res = await this.recomendacaoService.obter("", true);
		if (res.sucesso) this.listaRecomendacoes = res.dados;
	}

	public verificarTamanho(e: any) {
		const textoSemTags = e.replace(/(<([^>]+)>)/gi, "").replace(/\s+/g, " ").trim();
		return textoSemTags.length > 1000;
	}

	public get nomeRecomendacaoSelecionada(): string {
		return (
			this.modelConstatacaoRecomendacao.recomendacao?.nome ??
			this.nomeRecomendacaoPorId(
				this.modelConstatacaoRecomendacao.recomendacaoId
			)
		);
	}

	public nomeRecomendacaoPorId(id: number): string {
		if (!id) return "";
		return this.listaRecomendacoes.find((r) => r.id === id)?.nome ?? "";
	}

	private enriquecerRecomendacoes() {
		if (!this.model.constatacaoRecomendacao) return;
		this.model.constatacaoRecomendacao.forEach((item) => {
			if (!item.recomendacao && item.recomendacaoId) {
				item.recomendacao = this.listaRecomendacoes.find(
					(r) => r.id === item.recomendacaoId
				);
			}
		});
	}

	private async carregarDetalhes() {
		try {
			if (!this.novoRegistro && this.id) {
				this.model.id = this.id;
				this.novoRegistro = false;
				const res = await this.constatacaoService.obterPorId(this.model.id);
				if (res.sucesso) {
					this.model = res.dados;
					this.enriquecerRecomendacoes();
					if (this.visualizar) {
						this.titulo = "Visualização de Constatação - " + this.model.nome;
						this.form.controls["contaGovernador"].disable();
						this.form.controls["contaOrdenador"].disable();
					} else {
						this.titulo = "Editar Constatação - " + this.model.nome;
					}
					this.recomendacaoDataSource = new MatTableDataSource<IConstatacaoRecomendacaoModel>(this.model.constatacaoRecomendacao);
					this.recomendacaoDataSource._updateChangeSubscription();
					this.semDados = this.recomendacaoDataSource.filteredData.length === 0;
				} else {
					this.exibirMensagemAlerta(res.mensagem.descricao);
					this.router.navigate(["/constatacao"]);
					return;
				}
			}
			this.form.patchValue(this.model);
		} catch (err) {
			this.exibirMensagemErro(err.mensagem.descricao);
			this.router.navigate(["/constatacao"]);
		}
	}

	public async onSubmit(salvarEFechar: boolean = false) {
		if (this.verificarTamanho(this.form.controls["descricao"].value)) {
			Swal.fire({
				toast: true,
				position: "top-end",
				icon: "warning",
				text: "O campo Descrição não pode ter mais que 1000 caracteres",
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			});
			return;
		}
		if (this.form.invalid) {
			this.exibirMensagemAlerta("Formulário inválido!");
			return;
		}

		this.atualizarModel(this.form.value);
		this.model.constatacaoRecomendacao = this.recomendacaoDataSource.data;

		try {
			let res: IBaseModel<IConstatacaoModel> = null;
			if (!this.novoRegistro) {
				this.model.id = this.model.id ?? this.id;
				if (this.model.ativo == null) this.model.ativo = true;
				res = await this.constatacaoService.atualizar(this.model);
			} else {
				res = await this.constatacaoService.inserir(this.model);
				if (res.sucesso) {
					// Preserva o objeto retornado (inclui ativo=true) para que o
					// próximo "Salvar" (PUT) não inative o registro.
					this.model = res.dados;
					this.id = res.dados.id;
					this.novoRegistro = false;
					this.form.patchValue(this.model);
				}
			}

			if (res.sucesso) {
				// Aguarda o vínculo das recomendações antes de recarregar/fechar/
				// navegar — sem o await, o "Salvar" recarregava antes do POST de
				// vínculo concluir e a recomendação incluída sumia da tela.
				await this.vincularConstatacaoRecomendacao(this.model.id);
				this.exibirMensagemSucesso("Registro salvo com sucesso!");
				if (this.isModal) {
					if (salvarEFechar) {
						let questaoIdValeu = this.data?.model?.id ?? null;
						this.dialogRef.close({
							constatacaoId: this.model.id,
							constatacao: this.model,
							questaoId: questaoIdValeu,
						});
					} else {
						await this.carregarDetalhes();
						return;
					}
				} else {
					if (salvarEFechar) {
						this.router.navigate(["/constatacao"]);
						return;
					}
					// Fluxo Matriz de Planejamento (via questão): mantém vínculo local
					// e retorna à questão. No cadastro standalone recarrega do banco
					// para refletir o que foi persistido (vale para novo e edição).
					if (this.modelQuestao?.id) {
						this.listaConstatacao.push({
							constatacaoId: this.model.id,
							constatacao: this.model,
							questaoId: this.modelQuestao.id,
						} as IQuestaoConstatacaoModel);
						this.router.navigate(["/questao/" + this.modelQuestao.id], {
							state: {
								model: this.modelQuestao,
								modelMatrizPlanejamento: this.modelMatrizPlanejamento,
								modelSubtipoAuditoria: this.modelSubtipoAuditoria,
								listaProcedimentoAuditoria: this.listaProcedimentoAuditoria,
								listaQuestao: this.listaQuestao,
								listaConstatacao: this.listaConstatacao,
								listaMatrizPlanejamento: this.listaMatrizPlanejamento,
								rotaPrefixoSubtipoAuditoria: this.rotaPrefixoSubtipoAuditoria,
								rotaPrefixoMatrizPlanejamento: this.rotaPrefixoMatrizPlanejamento,
							},
						});
					} else {
						await this.carregarDetalhes();
						return;
					}
				}
			} else {
				const validacoes = this.montarMensagensValidacao(res);
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "warning",
					text: res.mensagem.descricao,
					title: validacoes,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		} catch (err) {
			this.exibirMensagemErro(err.mensagem.descricao);
		}
	}

	public async vincularConstatacaoRecomendacao(id: number) {
		const recomendacoes = (this.recomendacaoDataSource.data || [])
			.map((item) => item.recomendacaoId)
			.filter((v) => v != null);
		// Backend rejeita lista vazia; remoção total é feita via desvincular.
		if (!id || recomendacoes.length === 0) return;
		await this.constatacaoService.vincularConstatacaoRecomendacao(id, {
			recomendacoes,
		});
	}

	public incluirRecomendacao() {
		if (
			this.recomendacaoDataSource.data.findIndex(
				(a) =>
					a.recomendacaoId ===
					this.modelConstatacaoRecomendacao.recomendacaoId
			) >= 0
		) {
			this.exibirMensagemAlerta(
				"Recomendação já cadastrado nessa constatação"
			);
			return;
		}

		if (!this.modelConstatacaoRecomendacao.recomendacao &&
			this.modelConstatacaoRecomendacao.recomendacaoId) {
			this.modelConstatacaoRecomendacao.recomendacao =
				this.listaRecomendacoes.find(
					(r) => r.id === this.modelConstatacaoRecomendacao.recomendacaoId
				);
		}

		this.recomendacaoDataSource.data.push(
			cloneDeep(this.modelConstatacaoRecomendacao)
		);
		this.recomendacaoDataSource._updateChangeSubscription();
		this.modelConstatacaoRecomendacao = {} as IConstatacaoRecomendacaoModel;
		this.semDados = false;
	}

	public desvincularRecomendacao(element: IRecomendacaoModel, index: number) {
		if (element?.id) {
			this.constatacaoService
				.desvincularConstatacaoRecomendacao(this.id, element.id)
				.then((res) => {
					res.sucesso
						? this.exibirMensagemSucesso(res.mensagem.descricao)
						: this.exibirMensagemErro(res.mensagem.descricao);
					this.ngOnInit();
				});
		}
		this.recomendacaoDataSource.data.splice(index, 1);
		this.recomendacaoDataSource._updateChangeSubscription();
		this.semDados = this.recomendacaoDataSource.filteredData.length === 0;
	}

	public async visualizarRecomendacao(element: IConstatacaoRecomendacaoModel) {
		try {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.id = "modal-component";
			dialogConfig.width = "650px";
			dialogConfig.hasBackdrop = true;
			dialogConfig.disableClose = true;
			dialogConfig.data = element;
			this.matDialog.open(ModalRecomendacaoComponent, dialogConfig);
		} catch (err) {
			this.exibirMensagemErro(err);
		}
	}

	public async exibirModalRecomendacao() {
		try {
			const res = await this.recomendacaoService.obter("", true);
			if (res.sucesso) {
				const dadosFiltrados = res.dados.filter((recomendacao) => {
					const encontrado = this.recomendacaoDataSource.data?.find(
						(item) => item.recomendacaoId === recomendacao.id
					)?.recomendacaoId;
					if (encontrado) {
						return false;
					}
					return true;
				});
				const modal = this.exibirModal(
					"Selecionar Recomendação",
					dadosFiltrados
				);
				modal.afterClosed().subscribe((data) => {
					if (data) {
						this.modelConstatacaoRecomendacao.recomendacaoId =
							data.id;
						this.modelConstatacaoRecomendacao.recomendacao = data;
					}
				});
			} else {
				this.exibirMensagemAlerta(
					"Ocorreu um erro ao busca recomendações"
				);
			}
		} catch (err) {
			this.exibirMensagemErro("Ocorreu um erro ao busca recomendações");
		}
	}

	private atualizarModel(values: any) {
		Object.assign(this.model, values);
	}

	public onBack() {
		if (this.isModal) {
			this.dialogRef.close();
			return;
		}
		if (this.modelQuestao) {
			this.router.navigate(["/questao/novo"], {
				state: {
					model: this.modelQuestao,
					modelMatrizPlanejamento: this.modelMatrizPlanejamento,
					modelSubtipoAuditoria: this.modelSubtipoAuditoria,
					listaProcedimentoAuditoria: this.listaProcedimentoAuditoria,
					listaConstatacao: this.listaConstatacao,
					listaQuestao: this.listaQuestao,
					listaMatrizPlanejamento: this.listaMatrizPlanejamento,
					rotaPrefixoSubtipoAuditoria:
						this.rotaPrefixoSubtipoAuditoria,
					rotaPrefixoMatrizPlanejamento:
						this.rotaPrefixoMatrizPlanejamento,
				},
			});
		} else {
			this.router.navigate(["/constatacao"]);
		}
	}
}
